module.exports = {
	"id": "DK",
	"name": "Denmark",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.006539,
			"19": null,
			"20": null,
			"21": 0.006539,
			"22": 0.013078,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.006539,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.039234,
			"32": 0.013078,
			"33": 0.026156,
			"34": 0.032695,
			"35": 0.019617,
			"36": 0.013078,
			"37": 0.013078,
			"38": 0.039234,
			"39": 0.045773,
			"40": 0.019617,
			"41": 0.06539,
			"42": 0.052312,
			"43": 0.078468,
			"44": 0.06539,
			"45": 0.045773,
			"46": 0.045773,
			"47": 0.045773,
			"48": 0.078468,
			"49": 1.007006,
			"50": 0.098085,
			"51": 0.843531,
			"52": 0.52312,
			"53": 25.802894,
			"54": 6.545539,
			"55": 0.045773,
			"56": 0.013078,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.006539,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.013078,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": 0.026156,
			"36": 0.019617,
			"37": 0.006539,
			"38": 0.032695,
			"39": 0.045773,
			"40": 0.019617,
			"41": 0.013078,
			"42": 0.019617,
			"43": 0.06539,
			"44": 0.019617,
			"45": 0.078468,
			"46": 0.045773,
			"47": 0.287716,
			"48": 0.438113,
			"49": 5.290051,
			"50": 0.026156,
			"51": 0.006539,
			"52": null,
			"3.5": null,
			"3.6": null
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.045773,
			"34": null,
			"35": null,
			"36": 0.006539,
			"37": 0.013078,
			"38": 0.039234,
			"39": null,
			"40": 0.268099,
			"41": 0.045773,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.026156
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.045773,
			"6": null,
			"7": 0.058851,
			"8": 0.379262,
			"9": 0.516581,
			"10": 4.008407,
			"3.1": null,
			"3.2": null,
			"5.1": 0.078468,
			"6.1": 0.098085,
			"7.1": 0.019617,
			"9.1": 2.831387
		},
		"ios_saf": {
			"8": 0,
			"10": 13.7484147302,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.370503868339,
			"8.1-8.4": 0.68449019744,
			"9.0-9.2": 0.326545782265,
			"9.3": 4.98191642173
		},
		"android": {
			"3": 0,
			"4": 0.0128334237726,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00160417797158,
			"4.1": 0.0462919928941,
			"4.2-4.3": 0.115729982235,
			"4.4": 0.265376870155,
			"4.4.3-4.4.4": 0.267668552972
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.124419635514,
			"9": 0.268484476636,
			"10": 0.242290869159,
			"11": 8.47363201869,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0057283131637,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000159119810103
		},
		"edge": {
			"12": 0.091546,
			"13": 0.91546,
			"14": 3.439514
		},
		"ie_mob": {
			"10": 0.0934957464789,
			"11": 0.380661253521
		},
		"bb": {
			"7": 0.00259575,
			"10": null
		},
		"samsung": {
			"0": 2.917623
		},
		"and_uc": {
			"0": 0.169589
		},
		"op_mini": {
			"0": 0.0771765670262
		},
		"and_chr": {
			"0": 10.316204
		},
		"and_ff": {
			"0": 0.048454
		}
	},
	"total": 98.98065275
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/DK.json
 ** module id = 508
 ** module chunks = 0
 **/